import { createFileRoute, Outlet } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { PortalRouteShell } from "@/components/portal/portal-route-shell";
import { loadPortalRouteShell } from "@/components/portal/portal-route-shell.server";
import { sanitizeReturnTo } from "@/lib/portal-auth-shared";

const loadShell = createServerFn({ method: "GET" })
  .validator((input: string) => sanitizeReturnTo(input))
  .handler(({ data }) => loadPortalRouteShell({ nextPath: data }));

export const Route = createFileRoute("/_portal")({
  loader: ({ location }) => loadShell({ data: location.href }),
  component: PortalLayout,
});

function PortalLayout() {
  return <PortalRouteShell data={Route.useLoaderData()}><Outlet /></PortalRouteShell>;
}
